webpackJsonp([56],{

/***/ 1296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_filters__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_AmountsComponent__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_AmountsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_AmountsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_RoomStatus__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_RoomStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_shared_RoomStatus__);




var changeState = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var modelSend;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						modelSend = {
							idState: this.stateSelected.id,
							rooms: this.roomsSelected.map(function (room) {
								var newRoom = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, room);
								return newRoom.id;
							})
						};
						_context.next = 3;
						return this.$http.put('//pms.controlinn.com/api' + '/rooms-state', modelSend);

					case 3:
						this.showNotification('El estado de las habitaciones se actualizó correctamente.', 'success');
						this.closeModal();
						this.loadData();

					case 6:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function changeState() {
		return _ref.apply(this, arguments);
	};
}();

var loadBuilding = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var _this = this;

		var subsidiaryId, _ref3, buildings;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						subsidiaryId = this.params.subsidiaryId;
						_context2.next = 3;
						return this.$http.get('//pms.controlinn.com/api' + '/building', { params: { subsidiaryId: subsidiaryId } });

					case 3:
						_ref3 = _context2.sent;
						buildings = _ref3.data;

						this.params.buildingId = 0;
						this.buildings = [{ id: 0, nameBuild: 'Todos' }];
						buildings.data.forEach(function (building) {
							_this.buildings.push(building);
						});

					case 8:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadBuilding() {
		return _ref2.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var _ref5, rooms;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						this.params.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(new Date(), 'YYYY-MM-DD');
						if (this.params.buildingId === 0) {
							delete this.params.buildingId;
						}
						if (this.params.floorId === 'Todos') {
							delete this.params.floorId;
						}
						if (this.params.roomtypesId === 0) {
							delete this.params.roomtypesId;
						}
						if (this.params.stateId === 0) {
							delete this.params.stateId;
						}

						if (!(this.params.subsidiaryId > 0)) {
							_context3.next = 11;
							break;
						}

						_context3.next = 8;
						return this.$http.get('//pms.controlinn.com/api' + '/rooms-planning', { params: this.params });

					case 8:
						_ref5 = _context3.sent;
						rooms = _ref5.data;

						this.rooms = rooms.data.map(function (room) {
							var newRoom = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, room);
							newRoom.isAdded = false;
							newRoom.isSelected = false;
							newRoom.colorState = room.msState ? room.msState.data.colorState : '#000000';
							newRoom.codeRoomtype = room.roomTypes ? room.roomTypes.data.codeRoomtype : '';
							newRoom.extraState = room.flagBooking ? 'booking' : null;
							newRoom.iconUrl = room.msState ? room.msState.data.iconUrl : '';
							return newRoom;
						});

					case 11:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadData() {
		return _ref4.apply(this, arguments);
	};
}();

var loadHotel = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var _ref7, subsidiaries, subsidiary;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						_context4.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/hotel');

					case 2:
						_ref7 = _context4.sent;
						subsidiaries = _ref7.data;

						this.subsidiaries = subsidiaries.data;
						subsidiary = subsidiaries.data[0];

						this.params = {
							subsidiaryId: subsidiary.id
						};

					case 7:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function loadHotel() {
		return _ref6.apply(this, arguments);
	};
}();

var loadRoomtype = function () {
	var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id) {
		var _this2 = this;

		var idBuilding, _ref9, roomtypes;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						idBuilding = id || this.params.buildingId;
						_context5.next = 3;
						return this.$http.get('//pms.controlinn.com/api' + '/roomtype/' + this.params.subsidiaryId, { params: { idBuilding: idBuilding } });

					case 3:
						_ref9 = _context5.sent;
						roomtypes = _ref9.data;

						this.params.roomtypesId = 0;
						this.roomTypes = [{ id: 0, name: 'Todos' }];
						roomtypes.data.forEach(function (roomType) {
							_this2.roomTypes.push(roomType);
						});

					case 8:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this);
	}));

	return function loadRoomtype(_x) {
		return _ref8.apply(this, arguments);
	};
}();

var loadStates = function () {
	var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
		var _this3 = this;

		var _ref11, states;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
						_context6.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/states');

					case 2:
						_ref11 = _context6.sent;
						states = _ref11.data;

						this.states = states.data;
						this.params.stateId = 0;
						this.statesFilter = [{ id: 0, name: 'Todos' }];
						states.data.forEach(function (state) {
							_this3.statesFilter.push(state);
						});

					case 8:
					case 'end':
						return _context6.stop();
				}
			}
		}, _callee6, this);
	}));

	return function loadStates() {
		return _ref10.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function created() {
	this.loadStates();
	this.loadHotel();
}

function cleanData() {
	this.rooms = this.rooms.map(function (room) {
		var newRoom = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, room);
		newRoom.isSelected = false;
		return newRoom;
	});
	this.roomsSelected = [];
}

function closeModal() {
	this.dialog = false;
}

function disabledReservation() {
	return this.roomsSelected.length === 1;
}

function floorsEmpty() {
	return this.floors.length === 0;
}

function loadFloors(id) {
	this.loadRoomtype(id);
	delete this.params.floorId;
	if (id > 0) {
		var numFloors = this.buildings.find(function (b) {
			return b.id === id;
		}).floors;
		this.floors = ['Todos'];
		for (var index = 0; index < numFloors; index += 1) {
			this.floors.push(index + 1);
		}
	} else {
		this.floors = ['Todos'];
	}
	this.loadData();
}

function onChangeHotel() {
	this.loadBuilding();
	this.loadRoomtype();
	this.loadStates();
}

function openModal() {
	this.dialog = true;
}

function reservation() {
	this.$router.push({
		name: 'booking-new',
		query: {
			roomId: this.roomsSelected[0].id,
			roomTypeId: this.roomsSelected[0].roomTypes.data.id,
			hotelId: this.params.subsidiaryId,
			initDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
			endDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["addDays"])(new Date(), 1), 'YYYY-MM-DD')
		}
	});
}

function roomIsSelected(room) {
	if (room.isSelected) {
		this.roomsSelected.push(room);
	} else {
		var index = this.roomsSelected.findIndex(function (rs) {
			return rs.id === room.id;
		});
		this.roomsSelected.splice(index, 1);
	}
}

function roomsNotSelected() {
	return this.rooms.every(function (room) {
		return !room.isSelected;
	});
}

function stateIsSelected(state) {
	this.states = this.states.map(function (s) {
		var newS = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, s);
		newS.isSelected = s.id === state.id;
		return newS;
	});
	this.stateSelected = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state);
}

function data() {
	return {
		buildings: [],
		dialog: false,
		floors: [],
		params: {
			subsidiaryId: 0
		},
		rooms: [],
		roomsSelected: [],
		roomTypes: [],
		states: [],
		statesFilter: [],
		stateSelected: {},
		subsidiaries: []
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'planning-list',
	components: {
		amountsComponent: __WEBPACK_IMPORTED_MODULE_6__components_shared_AmountsComponent___default.a,
		RoomStatus: __WEBPACK_IMPORTED_MODULE_7__components_shared_RoomStatus___default.a
	},
	computed: {
		floorsEmpty: floorsEmpty,
		roomsNotSelected: roomsNotSelected,
		disabledReservation: disabledReservation
	},
	created: created,
	data: data,
	filters: {
		round: __WEBPACK_IMPORTED_MODULE_4__shared_filters__["c" /* round */]
	},
	methods: {
		changeState: changeState,
		cleanData: cleanData,
		closeModal: closeModal,
		loadBuilding: loadBuilding,
		loadData: loadData,
		loadFloors: loadFloors,
		loadHotel: loadHotel,
		loadRoomtype: loadRoomtype,
		loadStates: loadStates,
		onChangeHotel: onChangeHotel,
		openModal: openModal,
		reservation: reservation,
		roomIsSelected: roomIsSelected,
		stateIsSelected: stateIsSelected
	},
	mixins: __WEBPACK_IMPORTED_MODULE_5__shared_mixins__["a" /* default */]
});

/***/ }),

/***/ 1444:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".planning-container[data-v-f1ee6302]{background-color:#fff;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.1);box-shadow:0 2px 5px 0 rgba(0,0,0,.1);padding:0 10px 54px}.border-bottom[data-v-f1ee6302]{border-bottom:1px solid #dcdcdc}.caption .color[data-v-f1ee6302]{border-radius:3px;display:inline-block;height:10px;vertical-align:middle;width:10px}.caption span[data-v-f1ee6302]{display:inline-block;height:20px}.caption span img[data-v-f1ee6302]{vertical-align:middle}.caption .title[data-v-f1ee6302]{color:#6f7a83;font-family:San Francisco Display;font-size:12px!important;vertical-align:middle}.action-btn[data-v-f1ee6302]{background-color:#00b5ef!important;max-width:87px;min-width:87px}.action-btn[data-v-f1ee6302],.reservation-btn[data-v-f1ee6302]{-webkit-box-shadow:none!important;box-shadow:none!important;color:#fff;font-family:San Francisco Display Semi Bold;height:40px}.reservation-btn[data-v-f1ee6302]{background-color:#22b573!important;max-width:146px}.icon[data-v-f1ee6302]{margin-right:18px}.modal-card[data-v-f1ee6302]{background-color:#efefef}.modal-row[data-v-f1ee6302]{background-color:#fff}.modal-title[data-v-f1ee6302]{color:#353c4c;font-family:San Francisco Display Medium;font-size:14px}.header-booking-data[data-v-f1ee6302]{height:31px;position:absolute;right:20px;text-align:right;top:52px;width:calc(100% - 230px)}.header-booking-data-calendar[data-v-f1ee6302]{margin:0!important;position:static;width:100%}.header-booking-data div[data-v-f1ee6302]{padding-bottom:0!important;padding-top:0!important}.header-booking-data p[data-v-f1ee6302]{color:#2e394b;font-family:San Francisco Display;font-size:10px;margin:0;text-transform:uppercase}.header-booking-data span[data-v-f1ee6302]{color:#29abe2;font-family:San Francisco Display Medium;font-size:15px}.header-booking-data .border-select[data-v-f1ee6302]{border-right:1px solid #979797;margin-right:16px;padding-right:16px!important}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/planning/List.vue"],"names":[],"mappings":"AACA,qCACE,sBAAwB,AACxB,8CAAuD,AAC/C,sCAA+C,AACvD,mBAAuB,CACxB,AACD,gCACE,+BAAiC,CAClC,AACD,iCACE,kBAAmB,AACnB,qBAAsB,AACtB,YAAa,AACb,sBAAuB,AACvB,UAAY,CACb,AACD,+BACE,qBAAsB,AACtB,WAAa,CACd,AACD,mCACI,qBAAuB,CAC1B,AACD,iCACE,cAAe,AACf,kCAAqC,AACrC,yBAA2B,AAC3B,qBAAuB,CACxB,AACD,6BACE,mCAAqC,AAMrC,eAAgB,AAChB,cAAgB,CACjB,AACD,+DARE,kCAAoC,AAC5B,0BAA4B,AACpC,WAAa,AACb,4CAA+C,AAC/C,WAAa,CAYd,AARD,kCACE,mCAAqC,AAMrC,eAAiB,CAClB,AACD,uBACE,iBAAmB,CACpB,AACD,6BACE,wBAA0B,CAC3B,AACD,4BACE,qBAAwB,CACzB,AACD,8BACE,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACjB,AACD,sCACE,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,iBAAkB,AAClB,SAAU,AACV,wBAA0B,CAC3B,AACD,+CACI,mBAAuB,AACvB,gBAAiB,AACjB,UAAY,CACf,AACD,0CACI,2BAA+B,AAC/B,uBAA4B,CAC/B,AACD,wCACI,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,SAAY,AACZ,wBAA0B,CAC7B,AACD,2CACI,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACnB,AACD,qDACI,+BAAgC,AAChC,kBAAmB,AACnB,4BAA+B,CAClC","file":"List.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.planning-container[data-v-f1ee6302] {\n  background-color: white;\n  -webkit-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);\n          box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);\n  padding: 0px 10px 54px;\n}\n.border-bottom[data-v-f1ee6302] {\n  border-bottom: 1px solid #dcdcdc;\n}\n.caption .color[data-v-f1ee6302] {\n  border-radius: 3px;\n  display: inline-block;\n  height: 10px;\n  vertical-align: middle;\n  width: 10px;\n}\n.caption span[data-v-f1ee6302] {\n  display: inline-block;\n  height: 20px;\n}\n.caption span img[data-v-f1ee6302] {\n    vertical-align: middle;\n}\n.caption .title[data-v-f1ee6302] {\n  color: #6f7a83;\n  font-family: \"San Francisco Display\";\n  font-size: 12px !important;\n  vertical-align: middle;\n}\n.action-btn[data-v-f1ee6302] {\n  background-color: #00b5ef !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  color: white;\n  font-family: \"San Francisco Display Semi Bold\";\n  height: 40px;\n  max-width: 87px;\n  min-width: 87px;\n}\n.reservation-btn[data-v-f1ee6302] {\n  background-color: #22b573 !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  color: white;\n  font-family: \"San Francisco Display Semi Bold\";\n  height: 40px;\n  max-width: 146px;\n}\n.icon[data-v-f1ee6302] {\n  margin-right: 18px;\n}\n.modal-card[data-v-f1ee6302] {\n  background-color: #efefef;\n}\n.modal-row[data-v-f1ee6302] {\n  background-color: white;\n}\n.modal-title[data-v-f1ee6302] {\n  color: #353c4c;\n  font-family: \"San Francisco Display Medium\";\n  font-size: 14px;\n}\n.header-booking-data[data-v-f1ee6302] {\n  height: 31px;\n  position: absolute;\n  right: 20px;\n  text-align: right;\n  top: 52px;\n  width: calc(100% - 230px);\n}\n.header-booking-data-calendar[data-v-f1ee6302] {\n    margin: 0px !important;\n    position: static;\n    width: 100%;\n}\n.header-booking-data div[data-v-f1ee6302] {\n    padding-bottom: 0px !important;\n    padding-top: 0px !important;\n}\n.header-booking-data p[data-v-f1ee6302] {\n    color: #2e394b;\n    font-family: \"San Francisco Display\";\n    font-size: 10px;\n    margin: 0px;\n    text-transform: uppercase;\n}\n.header-booking-data span[data-v-f1ee6302] {\n    color: #29abe2;\n    font-family: \"San Francisco Display Medium\";\n    font-size: 15px;\n}\n.header-booking-data .border-select[data-v-f1ee6302] {\n    border-right: 1px solid #979797;\n    margin-right: 16px;\n    padding-right: 16px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1529:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1444);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("7b6e669a", content, true);

/***/ }),

/***/ 1701:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('amounts-component', {
    attrs: {
      "subsidiary-id": _vm.params.subsidiaryId
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "hide-details": "",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.subsidiaries,
      "single-line": ""
    },
    on: {
      "input": _vm.onChangeHotel
    },
    model: {
      value: (_vm.params.subsidiaryId),
      callback: function($$v) {
        _vm.params.subsidiaryId = $$v
      },
      expression: "params.subsidiaryId"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-start": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "item-text": "nameBuild",
      "item-value": "id",
      "label": "Edificio",
      "items": _vm.buildings,
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.loadFloors
    },
    model: {
      value: (_vm.params.buildingId),
      callback: function($$v) {
        _vm.params.buildingId = $$v
      },
      expression: "params.buildingId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "item-text": "name",
      "item-value": "id",
      "label": "Tipo Hab.",
      "items": _vm.roomTypes,
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.params.roomtypesId),
      callback: function($$v) {
        _vm.params.roomtypesId = $$v
      },
      expression: "params.roomtypesId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "item-text": "name",
      "item-value": "id",
      "label": "Estado",
      "items": _vm.statesFilter,
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.params.stateId),
      callback: function($$v) {
        _vm.params.stateId = $$v
      },
      expression: "params.stateId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "offset-xs2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "text-xs-left": ""
    }
  }, [_c('v-btn', {
    staticClass: "action-btn pr-1",
    attrs: {
      "disabled": _vm.roomsNotSelected
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openModal($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEditar\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "disabled": _vm.roomsNotSelected
    },
    on: {
      "click": _vm.cleanData
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLimpiar\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-btn', {
    staticClass: "reservation-btn",
    attrs: {
      "disabled": !_vm.disabledReservation
    },
    on: {
      "click": _vm.reservation
    }
  }, [_c('v-icon', {
    staticClass: "icon"
  }, [_vm._v("add")]), _vm._v("\n\t\t\t\t\t\t\t\tReserva\n\t\t\t\t\t\t\t")], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "planning-container"
  }, [_c('v-layout', {
    staticClass: "border-bottom",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "py-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "caption pl-1",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_vm._l((_vm.states), function(caption) {
    return _c('div', {
      key: caption.id,
      staticClass: "text-xs-left pr-4"
    }, [_c('span', {
      staticClass: "color",
      style: (("background-color: " + (caption.colorState)))
    }), _vm._v(" "), _c('label', {
      staticClass: "title"
    }, [_vm._v(_vm._s(caption.name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-left pr-4"
  }, [_c('span', {
    staticClass: "circle-booking"
  }, [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/booking-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "title"
  }, [_vm._v("Reservado")])])], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, _vm._l((_vm.rooms), function(room) {
    return _c('room-status', {
      key: room.id,
      attrs: {
        "background-color": room.colorState,
        "clean-state": room.cleanState,
        "code": room.codeRoomtype,
        "extra-state": room.extraState,
        "label-for": ("room-" + (room.id)),
        "number": room.codeRoom,
        "room": room,
        "show-circle": true,
        "status-icon-img": room.iconUrl
      },
      on: {
        "on-room-selected": _vm.roomIsSelected
      }
    })
  }))], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": 685
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "modal-card"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Cambiar de estado")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    staticClass: "modal-row",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "px-2": "",
      "justify-start": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "py-2": ""
    }
  }, [_c('label', {
    staticClass: "modal-title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tHabitaciones seleccionadas\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, _vm._l((_vm.roomsSelected), function(room) {
    return _c('room-status', {
      key: room.id,
      attrs: {
        "background-color": room.colorState,
        "clean-state": room.cleanState,
        "code": room.codeRoomtype,
        "extra-state": room.extraState,
        "label-for": ("room-" + (room.id)),
        "number": room.codeRoom,
        "room": room,
        "show-circle": true,
        "status-icon-img": room.iconUrl
      },
      on: {
        "on-room-selected": _vm.roomIsSelected
      }
    })
  }))], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "info": "",
      "x-large": ""
    }
  }, [_vm._v("arrow_downward")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "modal-row",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "px-2": "",
      "justify-start": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "py-2": ""
    }
  }, [_c('label', {
    staticClass: "modal-title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tDefine el estado de las habitaciones\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, _vm._l((_vm.states), function(state) {
    return _c('room-status', {
      key: state.id,
      attrs: {
        "background-color": state.colorState,
        "clean-state": state.clean_state,
        "code": state.code_roomtype,
        "extra-state": state.extra_state,
        "label-for": ("state-" + (state.id)),
        "name": state.name,
        "number": state.number,
        "room": state,
        "status-icon-img": state.icon_url
      },
      on: {
        "on-room-selected": _vm.stateIsSelected
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "error": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeModal($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pl-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "info": "",
      "disabled": _vm.roomsNotSelected
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeState($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tCambiar\n\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1529)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1296),
  /* template */
  __webpack_require__(1701),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f1ee6302",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 946:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_filters__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_mixins__ = __webpack_require__(56);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function subsidiaryId(id) {
	this.loadBookingsTotal(id);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'amounts-component',
	filters: {
		round: __WEBPACK_IMPORTED_MODULE_0__shared_filters__["c" /* round */]
	},
	mixins: __WEBPACK_IMPORTED_MODULE_1__shared_mixins__["a" /* default */],
	props: {
		subsidiaryId: {
			required: true,
			type: [Number, String]
		}
	},
	watch: {
		subsidiaryId: subsidiaryId
	}
});

/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, "p[data-v-5c70d746]{color:#2e394b;font-family:San Francisco Display;font-size:10px;margin:0;text-transform:uppercase}span[data-v-5c70d746]{color:#29abe2;font-family:San Francisco Display Medium;font-size:15px}.border-select[data-v-5c70d746]{border-right:1px solid #979797;padding-right:16px!important}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/AmountsComponent.vue"],"names":[],"mappings":"AACA,mBACE,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,SAAY,AACZ,wBAA0B,CAC3B,AACD,sBACE,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACjB,AACD,gCACE,+BAAgC,AAChC,4BAA+B,CAChC","file":"AmountsComponent.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\np[data-v-5c70d746] {\n  color: #2e394b;\n  font-family: \"San Francisco Display\";\n  font-size: 10px;\n  margin: 0px;\n  text-transform: uppercase;\n}\nspan[data-v-5c70d746] {\n  color: #29abe2;\n  font-family: \"San Francisco Display Medium\";\n  font-size: 15px;\n}\n.border-select[data-v-5c70d746] {\n  border-right: 1px solid #979797;\n  padding-right: 16px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(947);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("1474b784", content, true);

/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(948)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(946),
  /* template */
  __webpack_require__(950),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c70d746",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 950:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "border-select",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('p', [_vm._v("Ingresos")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.bookingsAmountTotal)))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', [_vm._v("Ocupación Actual")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bookingsTotal))])])], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/56.eeb794cda36a1fa71991.js